import {reactive, ref} from "vue";
import {useFetch} from "@/composables/useFetch";
import {BTNode} from "#/BTNode";
import {FetchResponse} from "ofetch";

const ofetch = useFetch()

export const queryParams = reactive({
  benefit: 203,
  sector: 0,
  multiDisplay: false,
})
export const bt = ref<BTNode>()
export const loading = ref(false)
export const debug = ref(false)
export const bsModalState = ref(false)

export const scaleValues = [
  {
    label: 'epb.bt.table.caption.high',
    color: 'hsl(201.33deg 41.67% 57.65%)',
    class: 'high',
  },
  {
    label: 'epb.bt.table.caption.medium',
    color: 'hsl(188.96deg 51.15% 74.31%)',
    class: 'medium',
  },
  {
    label: 'epb.bt.table.caption.low',
    color: 'hsl(189.23deg 52% 90.2%)',
    class: 'low',
  },
  {
    label: 'epb.bt.table.caption.none',
    color: 'transparent',
    class: 'none',
  },
  {
    label: 'epb.bt.table.caption.negative',
    color: 'hsl(331.17deg 72.64% 41.57%)',
    class: 'negative',
  },
]

export const topBenefitCategories = [
  {
    value: 203,
    label: 'Biophysical impacts',
  },
  {
    value: 211,
    label: 'Ecosystem Services Benefits',
  },
  {
    value: 205,
    label: 'Policy Objectives',
  }
]

interface BTQueryParams {
  benefit: number
  sector: number
}

export async function loadBT(nid: string, queryParams: BTQueryParams): Promise<void> {
  loading.value = true
  return ofetch<BTNode>(`/epbapi/bt/${nid}`, {
    params: {
      ...queryParams
    }
  })
    .then(response => {
      bt.value = response
    })
    .finally(() => loading.value = false)
}
